module.exports = __webpack_public_path__ + "static/media/yethi.b631f3d2.jpeg";